import React from 'react';
import { connect } from 'react-redux';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DialogCloseButton from '../../../../buttons/DialogCloseButton';
import { mediaPickerActions } from '../store';
import { useNavigate } from 'react-router-dom';
import { AnalyticsConstants, trackEvent } from '../../../../../utilities/analyticsUtilities';
import { executeCarefully } from '../../../../../utilities/basicUtilities';

const styles = theme => ({
    mainDialogMessage: {
        marginTop: theme.spacing(2),
    },
    videoElement: {
        width: '100%'
    }
});

const PremiumVideosDialog = (props) => {
    const { classes, dialogOpen, videoUrl, closePremiumVideosDialog, onGoBack } = props;
    const navigate = useNavigate();

    const onOptionsButtonClick = () => {
        navigate('/plans');
        closePremiumVideosDialog();

        trackEvent('Clicked CTA', {
            category: AnalyticsConstants.ACQUISITION_CATEGORY,
            color: 'white',
            destination: 'plans',
            location: 'premium videos dialog',
            text: 'OPTIONS',
            type: 'button'
        });
    };

    const onClose = () => {
        closePremiumVideosDialog();
        executeCarefully(onGoBack);
    };

    return (
        <Dialog
            open={dialogOpen}
            onClose={onClose}
            maxWidth='xs'
            fullWidth={true}
            aria-labelledby='premium-videos-dialog'
        >
            <DialogTitle id='premium-videos-dialog'>
                Animated Backgrounds
                <DialogCloseButton onClick={onClose} />
            </DialogTitle>
            <DialogContent>
                {videoUrl && (videoUrl.includes('blob:') || videoUrl.includes('.blob.core.') || videoUrl.includes("pexels"))
                    ?
                        <video 
                            className={classes.videoElement}
                            src={videoUrl} 
                            autoPlay
                            loop
                            muted
                        />
                    :
                        <iframe 
                            src={videoUrl + '&background=1'} 
                            width='395' 
                            height='220' 
                            frameBorder='0' 
                            allow='autoplay; fullscreen; picture-in-picture' 
                            allowFullScreen 
                            title='Specterr Catalog Video'
                        >
                        </iframe>
                }
                <Typography className={classes.mainDialogMessage}>
                    Upgrade your account to use videos and animations as your video background. 
                    Select from our library of nearly 100 HD videos or upload your own mp4 files.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Go Back
                </Button>
                <Button 
                    variant='outlined' 
                    color='secondary' 
                    onClick={onOptionsButtonClick}
                >
                    OPTIONS
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = (state) => {
    const { 
        dialogOpen, 
        videoUrl,
        onGoBack 
    } = state.mediaPicker.premiumVideosDialogData;

    return { 
        dialogOpen, 
        videoUrl,
        onGoBack
    };
}

const mapDispatchToProps = (dispatch) => {
    const closePremiumVideosDialog = () => dispatch(mediaPickerActions.closePremiumVideosDialog());
    return { closePremiumVideosDialog }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PremiumVideosDialog, styles));